module.exports = {
    name: "Fosse Green",

    holding: {
        "brand": "/assets/images/hero-image-cropped.png",
        "message": "Fosse Green Energy"
    },

    base: {
        "contact_address": "FREEPOST FOSSE GREEN ENERGY",
        "contact_number": "0800 860 6262",
        "contact_email": "info@fossegreenenergy.co.uk"
    },

    meta: {
        "defaultSocialImage": "/assets/images/hero-image-cropped.png",
        "author": "Fosse Green Energy",
        "description": "Fosse Green Energy is a proposal for a new solar and energy storage park and infrastructure to connect into the national grid. ",
    },

    consultation: {
        "has_countdown": false,
        "countdown_end": "03/31/2022 23:59:59", // Date format MM/DD/YYYY HH:MM:SS

        "themes": [
            {
                "name": "General",
                "url": "section-1",
                "feedback_url": '',
                "icon": "uncategorised",
                "question": "Do you have any overall comments on the plans for Fosse Green Energy?",
                "key": "01-section"
            },
            {
                "name": "Location",
                "url": "section-2",
                "feedback_url": 'page-2/',
                "icon": "landfall",
                "question": 'Do you have any comments on the locations for solar panels, substation and other associated infrastructure? You can see the locations of the different parts of the project on our layout plan available <a class="heading--link" href="/documents/">here</a>',
                "key": "02-section"
            },
            {
                "name": "Grid connection corridor",
                "url": "section-3",
                "feedback_url": 'page-3/',
                "icon": "highways_and_transport",
                "question": "Following the earlier non-statutory consultation we have selected one grid connection corridor which is proposed to connect Fosse Green Energy to the national grid. Please provide any comments on the grid connection corridor’s route.",
                "key": "03-section"
            },
            {
                "name": "Public Rights of Way",
                "url": "section-4",
                "feedback_url": 'page-4/',
                "icon": "access",
                "question": "We are presenting plans for permissive paths which would link to Public Rights of Ways and connect local villages. Please provide any comments you have on the routes for these paths.",
                "key": "04-section"
            },
            {
                "name": "Community",
                "url": "section-5",
                "feedback_url": 'page-5/',
                "icon": "heritage",
                "question": "Please provide your suggestions for community schemes or initiatives that we could support when the project is operational.",
                "key": "05-section"
            },
            {
                "name": "Ecology and landscape",
                "url": "section-6",
                "feedback_url": 'page-6/',
                "icon": "leisure_and_recreation",
                "question": 'Our layout plan available <a class="heading--link" href="/documents/">here</a> shows where we are planning planting, buffer areas and areas to deliver biodiversity net gain and habitat creation. Please let us know if you have any feedback on the location of these areas.',
                "key": "06-section"
            },
            {
                "name": "Access",
                "url": "section-7",
                "feedback_url": 'page-7/',
                "icon": "construction",
                "question": "We would need to construct the solar and energy storage project and grid connection, which would include using roads to access the site. Please let us know if you have any comments on how we plan to construct the project.",
                "key": "07-section"
            },
        ]
    },

    hasMap: false,

    // Ensure this URL does NOT have a trailing slash on the URL. Map reporting will fail.
    mapUrl: process.env.ELEVENTY_ENV === 'dev' ? '[STAGING LINK]' : '[PROD LINK]',
};
